import { AxiosInstance } from "axios"
import { SubscriptionOrder } from "./subscriptionsTypes"

type FetchSubscriptionsParams = Readonly<{
    companyId: number
    startDate: string
    endDate: string
    userGroupId: number
}>

export async function fetchSubscriptionsByPeriod(
    { companyId, userGroupId, startDate, endDate }: FetchSubscriptionsParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<SubscriptionOrder[]> {
    const url = `/companies/${companyId}/userGroups/${userGroupId}/accounting/subscriptions/orders`
    const { data } = await axios.get(url, {
        params: {
            startDate,
            endDate,
        },
        signal,
    })

    return data.orders
}

type CancelSubscriptionParams = Readonly<{
    orderId: number | string | undefined
    ignoreTerms: boolean
}>

type CancelSubscriptionResponse = Readonly<{
    transactionResponse: {
        subject: string
    }
}>

export async function cancelSubscription(
    { orderId, ignoreTerms }: CancelSubscriptionParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<CancelSubscriptionResponse> {
    const url = `/orders/subscriptions/${orderId}/unsubscribe`

    const { data } = await axios.post(url, {
        ignoreTerms,
    })

    return data
}
